import {nonBlank} from "../../libs/utils/epic.utils";

export class EmailDto {

  public id!: string;
  public email!: string;
  public prime: boolean = false;
  public label: string | undefined;
  public newsletter: boolean | undefined;
  public verified: boolean = false;

  constructor(init?: Partial<EmailDto> | undefined) {
    Object.assign(this, init);
    if (nonBlank(init?.email)) {
      this.email = init!.email!.trim().toLowerCase();
    }
    if (nonBlank(init?.label)) {
      this.label = init!.label!.trim();
    }
  }
}
